// extracted by mini-css-extract-plugin
export default {"favoritesWrapper":"_7924bc6a","icon":"_8f442515"};